import styled from 'styled-components';

import StepNumber from '~atoms/StepNumber';

const attrDisabled = '[disabled]';
const attrDataIsCompleted = '[data-is-completed="true"]';
const attrDataIsCurrent = '[data-is-current="true"]';

export const Content = styled.span(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '10rem',

  position: 'relative',

  paddingBlock: '10rem',
  borderBlock: '3rem solid transparent',

  textAlign: 'left',
  textTransform: 'uppercase',
  fontSize: theme.typography.size16,
  fontFamily: theme.typography.family.arial,
  color: 'inherit',

  transition: 'inherit',
}));

export const Container = styled.button(({ theme }) => ({
  paddingBlock: 0,
  paddingInline: '5rem',
  minHeight: '35rem',
  border: 'none',
  background: 'transparent',

  color: theme.header.primary.text,

  cursor: 'pointer',

  transition: ['250ms color linear', '250ms background linear'].join(', '),

  [`${StepNumber}`]: {
    transition: 'inherit',
  },

  [`&${attrDataIsCompleted} ${Content}, &${attrDataIsCurrent} ${Content}`]: {
    color: theme.header.primary.textActive,

    [`${StepNumber}`]: {
      background: theme.header.primaryAccent.bgActive,
      color: theme.header.primaryAccent.textActive,
    },
  },

  [`&:not(${attrDisabled}) ${Content}:hover`]: {
    color: theme.header.primary.textHover,

    [`${StepNumber}`]: {
      background: theme.header.primaryAccent.bgHover,
      color: theme.header.primaryAccent.textHover,
    },
  },

  [`&:not(${attrDisabled})${attrDataIsCurrent} ${Content}`]: {
    borderBlockEndColor: 'inherit',
  },

  [`&${attrDisabled}`]: {
    cursor: 'not-allowed',
  },
}));
